const languages = [
  { label: 'NO', value: 'no_NO', id: 1 },
  // { label: 'EN', value: 'en_US', id: 2 },
  { label: 'DA', value: 'da_DK', id: 3 },
  { label: 'SE', value: 'sv_SE', id: 4 },
]

export default languages
